export default [
    {
        id: 1,
        name_ca: 'Molt alt',
        name_en: 'Very high',
        name_es: 'Muy alto'
    },
    {
        id: 2,
        name_ca: 'Alt',
        name_en: 'High',
        name_es: 'Alto'
    },
    {
        id: 3,
        name_ca: 'Mitjà-alt',
        name_en: 'Medium-high',
        name_es: 'Medio alto'
    },
    {
        id: 4,
        name_ca: 'Mitjà',
        name_en: 'Medium',
        name_es: 'Medio'
    },
    {
        id: 5,
        name_ca: 'Mitjà-baix',
        name_en: 'Medium-low',
        name_es: 'Medio bajo'
    },
    {
        id: 6,
        name_ca: 'Baix',
        name_en: 'Low',
        name_es: 'Bajo'
    },
    {
        id: 7,
        name_ca: 'Molt baix',
        name_en: 'Very low',
        name_es: 'Muy bajo'
    }
]



// WEBPACK FOOTER //
// ./src/options/quality_masc_levels.js